<template>
    <div class="payment-form">
        <div class=" mb-4">
            <div class="h5">PAYMENT</div>
            <div><h6 class="el-icon-lock">All transactions are secure and encrypted with AES-256 bit encryption.</h6></div>
            <div style="color:red" v-if="paymentError != ''"><h6 class="el-icon-warning">{{paymentError}}</h6></div>
        </div>
        <div class="payment-option mb-4">
            <div style="border:1px solid #DCDFE6;border-radius:5px;">
                <el-radio-group v-model="method" class="w-100">
                    <div class="pl-2 pt-4 pb-3 border-bottom">
                        <el-radio label="card"><i class="el-icon-ship"></i> Credit Card </el-radio><span class="card-types"><img style="width:167px" src="data:image/png;base64, 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" /></span>
                    </div>
                    <div class="pl-2 pr-2 pt-4 pb-4 w-100 border-bottom" style="background-color:#fafafa" v-show="method=='card'">
                        <div id="card-element">
                        </div>                        
                    </div>
                    <div class="pl-2 pt-4 pb-3 border-bottom">
                        <el-radio label="GoogleApplePay"> Google/Apple Pay </el-radio><span class="card-types"><img style=" width: 80px; position: relative; top: -6px; left: -88px;" src="data:image/png;base64, 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" /></span>
                    </div>
                    <div v-show="method=='GoogleApplePay'" class="pl-2 pr-2 pt-4 pb-4 w-100 border-bottom" style="background-color:#fafafa">
                        <div id="payment-request-button" style="max-width: 200px; margin: 0 auto;">
                           <h5 v-show="!googleApplePaySupported" class="text-center">Apple and Google Pay Not Supported on this browser</h5>
                        </div>
                    </div>
                    <!--<div class="pl-2 pt-4 pb-3 justify-content-end">
                        <el-radio label="paypal"><i class="el-icon-present"></i> PayPal</el-radio>
                    </div>
                    <div class="pl-2 pr-2 pt-4 pb-4 w-100 border-top" style="background-color: #fafafa" v-show="method=='paypal'">
                        <div class="text-center w-100 ">
                            <i class="el-icon-finished" style="font-size: 150px; color: #ccc;"></i>
                            <p class="h6 text-center" style="max-width: 400px; margin: 0 auto;">After clicking "Complete order", you will be redirected to PayPal to complete your purchase securely.</p>
                        </div>
                    </div>-->
                </el-radio-group>
            </div>
        </div>
    </div>
</template>


<script>
    import axios from "axios"

    export default {
        name: 'PaymentForm',
        components: {},
        props: {
            clientSecret: String,
            customerName: String,
            total: Number            
        },
        data() {
            return {
                method: 'card',
                googleApplePaySupported: true,
                stripePK: '',                    
                stripeConnectedAccount: '',
                stripe: null,
                stripeElements: null,
                card: null,
                paymentError:''
            }
        },
        methods: {
            completePayment() {
                let $this = this;
                if (this.method == 'card') {
                    $this.stripe.confirmCardPayment(this.clientSecret, {
                        payment_method: {
                            card: $this.card,
                            billing_details: {
                                name: $this.customerName
                            }
                        }
                    }).then(function (result) {
                        if (result.error) {
                            // Show error to your customer (e.g., insufficient funds)
                            console.log(result.error.message);
                            $this.paymentError = result.error.message;
                            $this.$emit('payment-success', false, $this.method);
                        } else {
                            // The payment has been processed!
                            if (result.paymentIntent.status === 'succeeded') {
                                // Show a success message to your customer
                                // There's a risk of the customer closing the window before callback
                                // execution. Set up a webhook or plugin to listen for the
                                // payment_intent.succeeded event that handles any business critical
                                // post-payment actions.
                                $this.$emit('payment-success',true, $this.method);
                            }
                        }
                    });
                }
            }
        },
        computed: {
           
        },
        mounted() {
            let $this = this;
            axios.get("/api/Common/StripePK").then(response => {
                $this.StripePK = response.data;
                $this.stripe = window.Stripe(`${$this.StripePK[0]}`, { apiVersion: "2020-08-27", stripeAccount: `${$this.StripePK[1]}` });
                $this.stripeElements = $this.stripe.elements();
                var style = {
                    base: {
                        fontSize: '16px',
                        color: '#32325d',
                    },
                };
                // Create an instance of the card Element.
                $this.card = $this.stripeElements.create('card', { style: style });
                // Add an instance of the card Element into the `card-element` <div>.
                $this.card.mount('#card-element');

                $this.card.on('change', function (event) {
                    var displayError = document.getElementById('card-errors');
                    if (event.error) {
                        $this.paymentError = event.error.message;
                        $this.$emit('card-failure', event.error.message);
                    }
                    else {
                        if (event.complete) {
                            $this.paymentError = '';
                            $this.$emit('card-failure', null);
                        }
                        else {
                            $this.$emit('card-failure', "card not complete");
                        }
                    }
                });

                 //create payment button request
                var paymentRequest = $this.stripe.paymentRequest({
                    country: 'US',
                    currency: 'usd',
                    total: {
                        label: 'Colorado Jack Giveback Fundraising Order',
                        amount: parseInt(Math.round($this.total * 100), 10),
                    },
                    requestPayerName: true,
                    requestPayerEmail: true,
                });

                var prButton = $this.stripeElements.create('paymentRequestButton', {
                    paymentRequest: paymentRequest,
                });

                // Check the availability of the Payment Request API first.
                paymentRequest.canMakePayment().then(function (result) {
                    if (result) {
                        prButton.mount('#payment-request-button');
                    } else {
                        $this.googleApplePaySupported = false;
                    }
                });

                paymentRequest.on('paymentmethod', function (ev) {
                    // Confirm the PaymentIntent without handling potential next actions (yet).                   
                        $this.stripe.confirmCardPayment(
                            $this.clientSecret,
                            { payment_method: ev.paymentMethod.id },
                            { handleActions: false }
                        ).then(function (confirmResult) {
                            if (confirmResult.error) {
                                // Report to the browser that the payment failed, prompting it to
                                // re-show the payment interface, or show an error message and close
                                // the payment interface.
                                ev.complete('fail');
                                $this.$emit('payment-fail', $this.method);
                            } else {
                                // Report to the browser that the confirmation was successful, prompting
                                // it to close the browser payment method collection interface.
                                ev.complete('success');
                                // Check if the PaymentIntent requires any actions and if so let Stripe.js
                                // handle the flow. If using an API version older than "2019-02-11"
                                // instead check for: `paymentIntent.status === "requires_source_action"`.
                                if (confirmResult.paymentIntent.status === "requires_action") {
                                    // Let Stripe.js handle the rest of the payment flow.
                                    $this.stripe.confirmCardPayment($this.clientSecret).then(function (result) {
                                        if (result.error) {
                                            // The payment failed -- ask your customer for a new payment method.
                                            $this.$emit('payment-fail', $this.method);
                                        } else {
                                            // The payment has succeeded.
                                            $this.$emit('payment-success', $this.method);
                                        }
                                    });
                                } else {
                                    // The payment has succeeded.
                                    $this.$emit('payment-success', $this.method);
                                }
                            }
                        });
                });

            });

        },
        created() {
        }
    }
</script>


<style scoped>
  
</style>
